import { Component } from 'react';
import PropTypes from 'prop-types';
import { withProps } from 'recompose';
import { connect } from 'react-redux';
import moment from 'moment';
import { getPropertyProfile } from 'js/actions/pdfReports';
import Reports from 'js/constants/reports';
import PDFViewer from 'js/components/reports/PDFViewer';

class RentalEstimateReport extends Component {
    static propTypes = {
        propertyId: PropTypes.number,
        propertyAddress: PropTypes.string,
        pageContext: PropTypes.string,
        dispatch: PropTypes.func,
        rentalAvmEstimateReportId: PropTypes.number,
        trigger: PropTypes.object,
        entryPoint: PropTypes.string,
        route: PropTypes.object,
    };

    static defaultProps = {
        entryPoint: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            filename: null,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.propertyId !== prevState.id) {
            const dateNow = moment().format('DD-MM-YYYY');
            return {
                id: nextProps.propertyId,
                filename: `Rental_Valuation_Estimate_AVM_${nextProps.propertyAddress && nextProps.propertyAddress.replace(/\s/g, '_')}_${dateNow}`,
            };
        }
        return null;
    }

    handler = () => {
        const {
            route, dispatch, rentalAvmEstimateReportId,
        } = this.props;
        const { id } = this.state;
        dispatch(getPropertyProfile(
            id,
            route?.pageContext,
            Reports.RENTAL_ESTIMATE,
            rentalAvmEstimateReportId,
            this.props.entryPoint,
        ));
    };

    render() {
        const { entryPoint, propertyId } = this.props;
        return (
            <PDFViewer
                propertyId={propertyId}
                trigger={this.props.trigger}
                title={this.props.propertyAddress}
                filename={this.state.filename}
                triggerHandler={this.handler}
                reportType={Reports.RENTAL_ESTIMATE}
                entryPoint={entryPoint}
            />
        );
    }
}
const enhance = withProps({
    rentalAvmEstimateReportId: Reports.REPORT_ID.rentalAvmEstimateReport,
});

const ConnectedRentalEstimateReport = connect()(enhance(RentalEstimateReport));
ConnectedRentalEstimateReport.displayName = 'RentalEstimateReport';
export default ConnectedRentalEstimateReport;
